import { useState } from 'react';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '何本から注文できますか?',
      answer: '6本からご注文いただけます。',
    },
    {
      question: '配達日の指定はできますか?',
      answer: 'お支払い確認後、営業日5日以内に発送いたします。配達日のご希望がある場合は、LINEにてご相談ください。',
    },
    {
      question: '支払い方法を教えてください。',
      answer: '銀行振込でお支払いください。お振込先の詳細は、ご注文確定後にLINEにてご案内いたします。',
    },
    {
      question: '複数のデザインをお願いできますか?',
      answer: '可能です。複数のデザインをご希望の場合は、それぞれのデザインについてご相談させていただきます。',
    },
    {
      question: '初めてでもデザインを決められますか?',
      answer: 'はい！参考画像をLINEで送っていただければ、プロのデザイナーがご提案します。お気軽にご相談ください。',
    },
    {
      question: 'サンプルを見ることはできますか?',
      answer: '過去の制作実績をLINEにてお送りしています。LINE友達追加後、すぐにご覧いただけます。',
    },
  ];

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-24 bg-gradient-to-b from-purple-950/20 to-black">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            よくある質問
          </h2>
          <p className="text-xl text-gray-300">
            お客様からよくいただくご質問にお答えします
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-purple-900/30 to-black/50 rounded-2xl border border-purple-500/20 overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(index)}
                className="w-full flex items-center justify-between p-6 text-left hover:bg-purple-900/20 transition-colors duration-300 cursor-pointer"
              >
                <span className="text-lg font-bold text-white pr-4">{faq.question}</span>
                <div className="w-10 h-10 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-xl text-black transition-transform duration-300`}
                  ></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="p-6 pt-0 text-gray-300 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}